import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
	const navigate = useNavigate();

	useEffect(() => {
		// Clear any auth tokens here
		localStorage.removeItem("token");
		navigate("/login"); // or wherever your login page is
	}, [navigate]);

	return <div className='p-4'>Logging out...</div>;
};

export default Logout;
